import { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AppBar.css";
import TaskPopup from "../pages/Tasks/TaskPopup";

const VersionHistoryAppBar = ({
  title = "null",
  path,
  isSection = false,
  partId,
  revisionId,
  sectionId = "null",
  isStep = false,
  stepId,
  isPart = false,
  substepId = "null",
  isSubstep = false,
  partNumber = "",
  revision = "",
  selectedSubstepTitle = "",
  siblingOrder = null,
  elementType,
  id = "",
  partType,
  description,
  status,
  steps,
  data,
  fromTreeId,
  fromStepSiblingOrder,
  fromStepTreeId,
  fromSubstepTreeId,
  fromSubstepSiblingOrder,
  section,
  stepTitle,
  elementTitle,
  savedDetailsForReviewing,
  savedDetails,
  versionHistoryData,
}) => {
  const navigate = useNavigate();
  const navigateToSelectProcedureScreen = () => {

    const elementTypeNormalized = elementType
      ?.toLowerCase()
      .replace(/\s+/g, "-");
    const siblingOrderStr = String(siblingOrder);

    const siblingIndex =
      (isStep && elementTypeNormalized !== "step") ||
      (isSubstep && !elementType?.toLowerCase().includes("subs"))
        ? parseInt(siblingOrderStr.split(",")[1]?.trim(), 10) - 1
        : parseInt(siblingOrderStr.split(",")[0]?.trim(), 10) - 1;

    navigate("/procedure-copy-select-procedure", {
      state: {
        siblingOrder: siblingIndex,
        elementType,
        id,
        title: title || data.title,
        type: partType || data.type,
        description,
        revision: data.revision || revision,
        partNumber: data.partNumber || partNumber,
        status: data.status,
        steps: data.steps || steps,
        sections: data.sections || [],
        fromRevision: data.revision || revision,
        sourceSubstepIndex: data.sourceSubstepIndex,
        sourceStepId: data.sourceStepId,
        sourceNodeId: data.sourceNodeId,
        targetSubstepIndex: data.targetSubstepIndex,
        targetStepId: data.targetStepId,
        targetNodeId: data.targetNodeId,
        sourceNodeIndex: data.sourceNodeIndex || data.childIndex,
        sourceSectionIndex: data.sourceSectionIndex,
        sourceStepIndex: data.stepIndex,
        savedDetailsForReviewing,
        copyTitle: `Copying ${title.split("(")[0].trim()} from ${
          data.partNumber || partNumber
        } Rev ${data.revision || revision} ${savedDetails} EST.`,
        revisionId,
        fromTreeId,
        fromSectionId: sectionId,
        fromSiblingOrder: data.fromSiblingOrder,
        partId,
        fromStepId: stepId,
        fromStepSiblingOrder: fromStepSiblingOrder || data.fromStepSiblingOrder,
        fromStepTreeId,
        fromSubstepTreeId,
        fromSubstepId: substepId,
        fromSubstepSiblingOrder:
          fromSubstepSiblingOrder ||
          data.sibling_order ||
          data.procedure_tree?.sibling_order,
        elementId:
          data.rich_text_node_id ||
          data.attachment_tree_node_id ||
          data.video_tree_node_id ||
          data.video_tree_node_ref ||
          data.canvas_tree_node_id,
        elementTreeId: data.procedure_tree_ref,
        section: data.section,
        richTextsByStep: data.richTextsByStep || data.richTexts,
        attachmentsByStep: data.attachmentsByStep || data.attachments,
        videosByStep: data.videosByStep || data.videos,
        formsByStep: data.formsByStep || data.forms,
        canvasesByStep: data.canvasesByStep || data.canvases,
        step: data.step,
        substep: data.substep,
        richTexts: data.richTexts,
        forms: data.forms,
        attachments: data.attachments,
        videos: data.videos,
        canvases: data.canvases,
        node: data.node,
        nodeType: data.nodeType,
        fromNodeId: data.fromNodeId,
        richTexts: data.richTexts || data.richTextsBySubstep,
        forms: data.forms || data.formsBySubstep,
        attachments: data.attachments || data.attachmentsBySubstep,
        videos: data.videos || data.videosBySubstep,
        canvases: data.canvases || data.canvasesBySubstep,
        substepsByStep: data.substepsByStep,
      },
    });
  };

  return (
    <>
      <header
        className="appbar"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px",
        }}
      >
        {/* Left Side: Cancel & Task Buttons */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <button
            className="cancel-button"
            onClick={() => {
              navigate("/version-history-preview", {
                state: {
                  revisionId: data.revisionId || revisionId,
                  revision: data.revision || revision,
                  status: data.status || status,
                  description: data.description || description,
                  partType: data.partType || data.type || partType,
                  partNumber: data.partNumber || partNumber,
                  type: partType,
                  revisionData: data.revisionData || [],
                  savedDetailsForReviewing,
                  title: `Copying ${title.split("(")[0].trim()} from ${
                    data.partNumber || partNumber
                  } Rev ${data.revision || revision} ${savedDetails}`,
                },
              });
            }}
          >
            Cancel
          </button>
        </div>

        {/* Centered Title */}
        <div
          style={{
            flexGrow: 1,
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <h1 className="section-element-title">{title} Selected</h1>
          <button
            className="appbar-button"
            onClick={() => {
              // Parse the title to determine type
              const lowerTitle = title.toLowerCase();
              let path = "";

              const commonParams = {
                sectionId: data.sectionId || sectionId,
                partId: partId || data.partId,
                revisionId: data.revisionId || revisionId,
                partNumber: data.partNumber || partNumber,
                revision: data.revision || revision,
                stepTitle: data.stepTitle || stepTitle,
                section: data.section || section,
                stepId: data.step || data.fromStepId || stepId,
                substepId: data.substepId || substepId || data.fromSubstepId,
                siblingOrder: data.siblingOrder || siblingOrder,
                elementTitle: data.elementTitle || elementTitle,
                elementType: title,
                id,
              };
              //localhost:3000/ri-doc-front/edit-step/a537ed34-2c72-43b0-8622-59fc7abe20e8/d9c04545-3d85-4d77-a88f-3429b29501f9/d4ca83af-e92f-4fba-8c94-6b86007857f7/undefined/null/Pro1058/Step%202/A-/Section%202/1/undefined
              http: if (lowerTitle.includes("section")) {
                path = `/edit-section/${sectionId}/${partId}/${revisionId}/${partNumber}/${revision}/${section}`;
              } else if (lowerTitle.includes("step")) {
                path = `/edit-step/${sectionId}/${partId}/${revisionId}/${stepId}/${substepId}/${partNumber}/${stepTitle}/${revision}/${stepTitle}/${section}/${siblingOrder}/${elementType}`;
              } else if (lowerTitle.includes("rich")) {
                path = `/edit-rich-text/${sectionId}/${partId}/${revisionId}/${stepId}/${substepId}/${partNumber}/${elementTitle}/${revision}/${stepTitle}/${section}/${siblingOrder}/${elementType}/${id}`;
              } else if (lowerTitle.includes("attachment")) {
                path = `/edit-attachment/${sectionId}/${partId}/${revisionId}/${stepId}/${substepId}/${partNumber}/${elementTitle}/${revision}/${stepTitle}/${section}/${siblingOrder}/${elementType}/${id}`;
              } else if (lowerTitle.includes("video")) {
                path = `/edit-video/${sectionId}/${partId}/${revisionId}/${stepId}/${substepId}/${partNumber}/${elementTitle}/${revision}/${stepTitle}/${section}/${siblingOrder}/${elementType}/${id}`;
              } else if (lowerTitle.includes("canvas")) {
                path = `/edit-canvas/${sectionId}/${partId}/${revisionId}/${stepId}/${substepId}/${partNumber}/${elementTitle}/${revision}/${stepTitle}/${section}/${siblingOrder}/${elementType}/${id}`;
              }

              navigate(path, {
                state: {
                  ...commonParams,
                  fromAppBar: true, // optional extra state
                  versionHistoryData: versionHistoryData?.version_content,
                },
              });
            }}
          >
            View
          </button>
        </div>

        {/* Right Side: Edit, Move, Copy, Delete Buttons */}
        <div style={{ display: "flex", alignItems: "flex-end", gap: "10px" }}>
          <button
            className="move-copy-button"
            onClick={() => {
              navigateToSelectProcedureScreen();
            }}
          >
            Copy
          </button>
        </div>
      </header>
    </>
  );
};

export default VersionHistoryAppBar;
